/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  assemble.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:25
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

export function assemble (arr: Array<any[]>, n: number) {
  let pass = new Set()
  let zh: any[] = []
  if (n < 0 || arr.length < n) {
    Error('参数错误')
  }
  if (n === 1) {
    for (let _arr of arr) {
      for (let v of _arr) {
        if (!pass.has(v)) { // 去重
          pass.add(v)
          zh.push([v])
        }
      }
    }
    return zh
  }
  for (let i = 0; i <= arr.length - n; i++) {
    for (let v of arr[i]) {
      if (!pass.has(v)) { // 去重
        pass.add(v)
        let _zh = assemble(arr.slice(i + 1), n - 1).map(a => {
          a.unshift(v)
          return a
        })
        zh = zh.concat(_zh)
      }
    }
  }
  return zh
}

/**
 * 获取两个数组的交集
 */
export function getIntersection (a: string[], b: string[]) {
  let setA = new Set(a)
  let setB = new Set(b)
  return a.filter(item => setB.has(item))
}
